// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__14520","inputWrap":"CustomTip_inputWrap__1C-XW"};